import { ApiReceivingLogRow } from "../logs/ApiReceivingLogRow";
import { EmailData } from "./EmailData";
import { ReceiptSubmitRow } from "../logs/ReceiptSubmitRow";
import { MissingItem } from "../logs/MissingItem";
/**
 * Request for adding a new receiving log with optional email data
 */
export class EmailPreviewRequest {
    public constructor(
        receivingLogRow: ApiReceivingLogRow,
        emailData: EmailData,
        receipts?: ReceiptSubmitRow[],
        missingItems?: MissingItem[],
        expeditingEmailData?: EmailData
      ) {
        this.receivingLogRow = receivingLogRow;
        this.emailData = emailData;
        this.receipts = receipts;
        this.missingItems = missingItems;
        this.expeditingEmailData = expeditingEmailData;
      }

    /**
     * The receiving log row data to be saved
     */
    receivingLogRow: ApiReceivingLogRow;

    /**
     * Optional email message data if an email should be sent
     */
    emailData: EmailData;

    /**
     * Structured receipt rows for this delivery. Supplied so the backend has the
     * per-line damage context (`isDamaged`/`damageNote`/`damageDisposition`) when
     * rendering. Omit when only the standard preview is needed.
     */
    receipts?: ReceiptSubmitRow[];

    /**
     * The outstanding items on this delivery (plain shortfalls + refused/returned
     * goods). When non-empty and `expeditingEmailData` is present, the backend
     * renders `EmailPreviewResponse.expeditingEmailPreview` from these.
     */
    missingItems?: MissingItem[];

    /**
     * Email config for the SEPARATE expediting / missing-items email (its own
     * recipients and include-photos choice). Present only when there are missing
     * items and the expediting email is left on. When present, the backend
     * populates `EmailPreviewResponse.expeditingEmailPreview`.
     */
    expeditingEmailData?: EmailData;
  }
